import axios from "./axios";

export async function fetchCaseSettings() {
  return axios.get("/cases/settings").then((response) => response.data);
}

export async function updateCaseSettings(payload) {
  return axios
    .put("/cases/settings", { case_setting: payload })
    .then((response) => response.data);
}
